const APIVersion = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <p className="mb-2 text-sm text-gray-600">
        Current Version - v0. <br/>
        Release - 01-JAN-2025. <br/>
        <p className="mt-2">
        No new versions available.
        </p>
      </p>
    </div>
  );
};

export default APIVersion;
